import { render, staticRenderFns } from "./ReviewOpen.vue?vue&type=template&id=368574f8"
import script from "./ReviewOpen.vue?vue&type=script&lang=js"
export * from "./ReviewOpen.vue?vue&type=script&lang=js"
import style0 from "./ReviewOpen.vue?vue&type=style&index=0&id=368574f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports